import { PlatformUtils } from '@eo-storefronts/eo-core'
import { AvatarProps, BadgeProps, LinkProps } from '@mui/material'
import { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom'
import { ButtonWithIconProps } from '~/src/components/mui-wrappers/buttons/ButtonWithIcon'
import LoginButton from '~/src/components/user-actions/LoginButton'
import LogoutButton from '~/src/components/user-actions/LogoutButton'
import ShowQrCodeButton from '~/src/components/user-actions/ShowQrCodeButton'
import ProfileDropdownButton from '~/src/components/user-actions/profile-dropdown-button'
import { useEoValue } from '~/src/hooks/useEoState'
import { AUTHENTICATION_STATE, AuthenticationState } from '~/src/stores/authentication'
import { BRAND_STATE } from '~/src/stores/brand'

export interface HeaderUserActionsProps {
  showLogoutBtn?: boolean,
  ButtonProps?: Omit<ButtonWithIconProps, 'startIcon' | 'onClick'>,
  LinkProps?: Omit<LinkProps, 'removeBaseLinkStyle' | 'href'>,
  BadgeProps?: BadgeProps,
  AvatarProps?: AvatarProps,
}

const HeaderUserActions = (
  {
    showLogoutBtn = true,
    ButtonProps,
    BadgeProps,
    AvatarProps
  }: HeaderUserActionsProps
) => {
  const { pathname } = useLocation()
  const brand = useEoValue(BRAND_STATE)
  const [ displayLogout, setDisplayLogout ] = useState<boolean>(false)
  const authState = useEoValue<AuthenticationState>(AUTHENTICATION_STATE)

  useEffect(() => {
    setDisplayLogout(pathname.includes('profile'))
  }, [ pathname ])

  if (!!authState.loggedInAs && authState.loggedInAs === 'customer') {
    if (displayLogout && showLogoutBtn) {
      return <LogoutButton {...ButtonProps} />
    }

    if (brand?.settings?.useQuickAuth &&
      (PlatformUtils().isMobileWeb || PlatformUtils().isCapacitorNative)
    ) {
      return (
        <ShowQrCodeButton
          AvatarProps={AvatarProps}
          BadgeProps={BadgeProps}/>
      )
    }

    return (
      <ProfileDropdownButton
        color={ButtonProps?.color}
        useAutomaticShading={ButtonProps?.useAutomaticShading}
        variant={ButtonProps?.variant}
        sx={ButtonProps?.sx}/>
    )
  }

  return (
    <LoginButton
      ButtonProps={ButtonProps}
    />
  )
}

export default HeaderUserActions
